var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.722 20.133c.386.39.378 1.027-.01 1.415l-.167.167a.988.988 0 0 1-1.408.003l-4.484-4.528 1.586-1.587 4.483 4.53zM8.968 15.697A6.734 6.734 0 0 1 2.242 8.97a6.735 6.735 0 0 1 6.726-6.728 6.735 6.735 0 0 1 6.727 6.728 6.734 6.734 0 0 1-6.727 6.727zM0 8.97A8.97 8.97 0 1 0 8.968 0 8.97 8.97 0 0 0 0 8.97z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchInactive);
export default __webpack_public_path__ + "static/media/icon_search_inactive.1efbee70eb2229892e00d83d69ad6661.svg";
export { ForwardRef as ReactComponent };